import {
  getStatusPageData,
  KNOWN_COMPONENT_IDS,
  StatusPageBanner as StatusPageBannerComponent,
  StatusPageInfo,
} from "@digipost/statusbanner/dist/src";
import { FC, useEffect, useState } from "react";

import { isDifitest, isProd } from "../env";

function getStatusPageComponentIds() {
  if (isProd) {
    return [KNOWN_COMPONENT_IDS.DIGIPOST_WEB];
  } else if (isDifitest) {
    return [KNOWN_COMPONENT_IDS.OFFENTLIG_TESTMILJO];
  } else {
    return [];
  }
}

const StatusPageBanner: FC = () => {
  const [statusData, setStatusData] = useState<StatusPageInfo[]>([]);

  useEffect(() => {
    getStatusPageData(getStatusPageComponentIds()).then(setStatusData);
  }, []);

  return <StatusPageBannerComponent statusPageInfo={statusData} />;
};

export default StatusPageBanner;
